"use strict";
exports.__esModule = true;
exports.Permissions = void 0;
exports.Permissions = {
    Staff: {
        Academics: {
            Externship: {
                View: 1011,
                Add: 1012,
                Edit: 1013,
                Delete: 1014
            },
            Instructional: {
                Lessons: {
                    Attendance: {
                        View: 1121,
                        Add: 1122,
                        Edit: 1123,
                        Delete: 1124
                    },
                    Grades: {
                        View: 1131,
                        Add: 1132,
                        Edit: 1133,
                        Delete: 1134
                    },
                    LessonDetails: {
                        Add: 6132,
                        Edit: 6133,
                        Delete: 6134
                    }
                },
                AttendanceOverview: {
                    View: 1141,
                    Add: 1142,
                    Edit: 1143,
                    Delete: 1144
                },
                CourseGrades: {
                    View: 1151,
                    Add: 1152,
                    Edit: 1153,
                    Delete: 1154
                },
                Students: {
                    PermissionsToAccessOthers: {
                        View: 2855,
                        Edit: 2856,
                        Delete: 2857
                    },
                    Checklist: {
                        View: 5831,
                        Add: 5832,
                        Edit: 5833,
                        Delete: 5834
                    },
                    AcademicsStudentDetails: {
                        View: 5841,
                        Add: 5842,
                        Edit: 5843,
                        Delete: 5844
                    }
                }
            },
            Practical: {
                Students: {
                    View: 1211,
                    Add: 1212,
                    Edit: 1213,
                    Delete: 1214
                },
                Submissions: {
                    View: 1221,
                    Add: 1222,
                    Edit: 1223,
                    Delete: 1224
                }
            },
            Registrar: {
                Workspace: {
                    View: 1311,
                    Add: 1312,
                    Edit: 1313,
                    Delete: 1314
                },
                Students: {
                    WorkspaceStudent: {
                        View: 1321,
                        Add: 1322,
                        Edit: 1323,
                        Delete: 1324
                    },
                    TermsAndCourses: {
                        View: 1331,
                        Add: 1332,
                        Edit: 1333,
                        Delete: 1334
                    },
                    AcademicPlanning: {
                        View: 1341,
                        Add: 1342,
                        Edit: 1343,
                        Delete: 1344
                    },
                    DegreeAudit: {
                        View: 1351,
                        Add: 1352,
                        Edit: 1353,
                        Delete: 1354
                    },
                    UpdateAdvisor: {
                        Edit: 1373
                    },
                    OfficialTranscript: {
                        View: 6144,
                        Add: 6145,
                        Edit: 6146,
                        Delete: 6147
                    },
                    ProgressReport: {
                        View: 6165,
                        Add: 6166,
                        Edit: 6167
                    }
                },
                Attendance: {
                    General: {
                        View: 1361,
                        Add: 1362,
                        Edit: 1363,
                        Delete: 1364
                    },
                    FacialData: {
                        View: 6203
                    },
                    AllowAddManualAttendance: {
                        Add: 6204
                    }
                }
            },
            Director: {
                View: 6074
            },
            AttendanceTerminal: {
                View: 6200
            },
            StudentSuccess: {
                View: 6205
            },
            EducatorSuccess: {
                View: 6206
            }
        },
        Admissions: {
            AdmissionsStaff: {
                View: 1451,
                Add: 1452,
                Edit: 1453,
                Delete: 1454,
                PermissionsToAccessOthers: {
                    View: 2858,
                    Edit: 2859,
                    Delete: 2860
                }
            },
            Students: {
                AdmissionsStudentDetails: {
                    View: 1461,
                    Add: 1462,
                    Edit: 1463,
                    Delete: 1464
                },
                UpdateAdvisor: {
                    Edit: 1473
                },
                PermissionsToAccessOthers: {
                    View: 2861,
                    Edit: 2862,
                    Delete: 2863
                },
                Checklist: {
                    View: 5821,
                    Add: 5822,
                    Edit: 5823,
                    Delete: 5824
                }
            },
            Director: {
                View: 6075
            }
        },
        CareerServices: {
            View: 1511,
            Add: 1512,
            Edit: 1513,
            Delete: 1514
        },
        FinancialAid: {
            FinancialAidStaff: {
                View: 1611,
                Add: 1612,
                Edit: 1613,
                Delete: 1614,
                PermissionsToAccessOthers: {
                    View: 2864,
                    Edit: 2865,
                    Delete: 2866
                }
            },
            Students: {
                FinancialAidStudentDetail: {
                    View: 1621,
                    Add: 1622,
                    Edit: 1623,
                    Delete: 1624
                },
                UpdateAdvisor: {
                    Edit: 1643
                },
                PermissionsToAccessOthers: {
                    View: 2867,
                    Edit: 2868,
                    Delete: 2869
                },
                Checklist: {
                    View: 5811,
                    Add: 5812,
                    Edit: 5813,
                    Delete: 5814
                }
            },
            Notices: {
                View: 1631,
                Add: 1632,
                Edit: 1633,
                Delete: 1634
            },
            Director: {
                View: 6076
            }
        },
        StudentAccount: {
            Workspace: {
                View: 1711,
                Add: 1712,
                Edit: 1713,
                Delete: 1714
            },
            Students: {
                StudentLedger: {
                    View: 1721,
                    Add: 1722,
                    Edit: 1723,
                    Delete: 1724
                },
                PaymentPlan: {
                    View: 1731,
                    Add: 1732,
                    Edit: 1733,
                    Delete: 1734
                },
                FinAid: {
                    View: 1741,
                    Add: 1742,
                    Edit: 1743,
                    Delete: 1744
                },
                Scholarship: {
                    View: 1751,
                    Add: 1752,
                    Edit: 1753,
                    Delete: 1754
                },
                UpdateAdvisor: {
                    Edit: 1773
                }
            },
            Orders: {
                View: 1761,
                Add: 1762,
                Edit: 1763,
                Delete: 1764
            },
            Director: {
                View: 6077
            }
        },
        StudentServicesAndAcademicAffairs: {
            StudentServices: {
                Workspace: {
                    View: 1811,
                    Add: 1812,
                    Edit: 1813,
                    Delete: 1814,
                    PermissionsToAccessOthers: {
                        View: 2870,
                        Edit: 2871,
                        Delete: 2872
                    }
                },
                Students: {
                    AcademicPlanning: {
                        View: 1831,
                        Add: 1832,
                        Edit: 1833,
                        Delete: 1834
                    },
                    DegreeAudit: {
                        View: 1841,
                        Add: 1842,
                        Edit: 1843,
                        Delete: 1844
                    },
                    UpdateAdvisor: {
                        Edit: 1893
                    },
                    PermissionsToAccessOthers: {
                        View: 2873,
                        Edit: 2874,
                        Delete: 2875
                    },
                    StudentDetail: {
                        View: 5851,
                        Add: 5852,
                        Edit: 5853,
                        Delete: 5854
                    },
                    Checklist: {
                        View: 5861,
                        Add: 5862,
                        Edit: 5863,
                        Delete: 5864
                    }
                }
            },
            AcademicAdvising: {
                Students: {
                    View: 1861,
                    Add: 1862,
                    Edit: 1863,
                    Delete: 1864
                },
                Advising: {
                    View: 1871,
                    Add: 1872,
                    Edit: 1873,
                    Delete: 1874
                }
            },
            Director: {
                View: 6078
            }
        },
        AcademicAffairs: {
            StudentServices: {
                Workspace: {
                    View: 1911,
                    Add: 1912,
                    Edit: 1913,
                    Delete: 1914
                },
                Students: {
                    StudentServices: {
                        View: 1921,
                        Add: 1922,
                        Edit: 1923,
                        Delete: 1924
                    },
                    AcademicPlanning: {
                        View: 1931,
                        Add: 1932,
                        Edit: 1933,
                        Delete: 1934
                    },
                    DegreeAudit: {
                        View: 1941,
                        Add: 1942,
                        Edit: 1943,
                        Delete: 1944
                    },
                    UpdateAdvisor: {
                        Edit: 1993
                    },
                    StudentDetail: {
                        View: 6011,
                        Add: 6012,
                        Edit: 6013,
                        Delete: 6014
                    },
                    Checklist: {
                        View: 6021,
                        Add: 6022,
                        Edit: 6023,
                        Delete: 6024
                    }
                },
                Attendance: {
                    View: 1951,
                    Add: 1952,
                    Edit: 1953,
                    Delete: 1954
                }
            },
            AcademicAdvising: {
                Students: {
                    View: 1961,
                    Add: 1962,
                    Edit: 1963,
                    Delete: 1964
                },
                Advising: {
                    View: 1971,
                    Add: 1972,
                    Edit: 1973,
                    Delete: 1974
                }
            },
            Director: {
                View: 6079
            },
            MakeUpAttendance: {
                MakeUpAttendanceSignOff: {
                    Edit: 6163
                },
                MakeUpAttendanceVerification: {
                    Edit: 6164
                }
            }
        },
        Settings: {
            General: {
                Calendar: {
                    AccessStaffList: {
                        View: 2011
                    },
                    AccessStudentList: {
                        View: 2021
                    },
                    AccessOthersList: {
                        View: 2031
                    },
                    UnlimitedUserSelection: {
                        View: 2041
                    },
                    SchoolClosures: {
                        Add: 2052,
                        Edit: 2053,
                        Delete: 2054
                    }
                },
                Campus: {
                    View: 2111,
                    Add: 2112,
                    Edit: 2113,
                    Delete: 2114
                },
                CareerServices: {
                    View: 2121,
                    Add: 2122,
                    Edit: 2123,
                    Delete: 2124
                },
                Courses: {
                    View: 2131,
                    Add: 2132,
                    Edit: 2133,
                    Delete: 2134
                },
                Chat: {
                    AccessStaffList: {
                        View: 2141,
                        Add: 2142,
                        Edit: 2143,
                        Delete: 2144
                    },
                    AccessStudentList: {
                        View: 2151,
                        Add: 2152,
                        Edit: 2153,
                        Delete: 2154
                    },
                    AccessOthersList: {
                        View: 2161,
                        Add: 2162,
                        Edit: 2163,
                        Delete: 2164
                    },
                    UnlimitedUserSelection: {
                        View: 2171,
                        Add: 2172,
                        Edit: 2173,
                        Delete: 2174
                    }
                },
                DegreeLevel: {
                    View: 2181,
                    Add: 2182,
                    Edit: 2183,
                    Delete: 2184
                },
                Department: {
                    View: 2191,
                    Add: 2192,
                    Edit: 2193,
                    Delete: 2194
                },
                Labels: {
                    View: 2201,
                    Add: 2202,
                    Edit: 2203,
                    Delete: 2204
                },
                Majors: {
                    View: 2211,
                    Add: 2212,
                    Edit: 2213,
                    Delete: 2214
                },
                ResourcesTypes: {
                    View: 2221,
                    Add: 2222,
                    Edit: 2223,
                    Delete: 2224
                },
                Tags: {
                    View: 2231,
                    Add: 2232,
                    Edit: 2233,
                    Delete: 2234
                },
                Terms: {
                    General: {
                        View: 2241,
                        Add: 2242,
                        Edit: 2243,
                        Delete: 2244
                    },
                    AddDropDate: {
                        View: 5741,
                        Add: 5742,
                        Edit: 5743,
                        Delete: 5744
                    }
                },
                Workflow: {
                    View: 5751,
                    Add: 5752,
                    Edit: 5753,
                    Delete: 5754
                },
                Coa: {
                    View: 5871,
                    Add: 5872,
                    Edit: 5873,
                    Delete: 5874
                },
                Sap: {
                    View: 5881,
                    Add: 5882,
                    Edit: 5883,
                    Delete: 5884
                },
                UserSettings: {
                    View: 6035,
                    Add: 6036,
                    Edit: 6037,
                    Delete: 6038
                },
                Groups: {
                    Add: 6070,
                    Delete: 6071,
                    Edit: 6072,
                    View: 6073
                },
                Sms: {
                    View: 6112,
                    Edit: 6113
                },
                Statuses: {
                    View: 6122,
                    Add: 6123,
                    Edit: 6124,
                    Delete: 6125
                },
                CourseLevels: {
                    View: 6138,
                    Add: 6139,
                    Edit: 6140,
                    Delete: 6141
                }
            },
            Modules: {
                Academics: {
                    View: 2251,
                    Add: 2252,
                    Edit: 2253,
                    Delete: 2254
                },
                Admissions: {
                    View: 2261,
                    Add: 2262,
                    Edit: 2263,
                    Delete: 2264
                },
                CareerServices: {
                    View: 2271,
                    Add: 2272,
                    Edit: 2273,
                    Delete: 2274
                },
                FinancialAid: {
                    View: 2281,
                    Add: 2282,
                    Edit: 2283,
                    Delete: 2284
                },
                StudentAccount: {
                    View: 2291,
                    Add: 2292,
                    Edit: 2293,
                    Delete: 2294
                },
                StudentServices: {
                    View: 6031,
                    Add: 6032,
                    Edit: 6033,
                    Delete: 6034
                }
            },
            SystemSettings: {
                AppStore: {
                    View: 2301,
                    Add: 2302,
                    Edit: 2303,
                    Delete: 2304
                },
                Branding: {
                    View: 2311,
                    Add: 2312,
                    Edit: 2313,
                    Delete: 2314
                },
                Media: {
                    View: 2321,
                    Add: 2322,
                    Edit: 2323,
                    Delete: 2324
                },
                Fields: {
                    Add: 6066,
                    Delete: 6067,
                    Edit: 6068,
                    View: 6069
                },
                EmailTemplates: {
                    Add: 6105,
                    Delete: 6106,
                    Edit: 6107,
                    View: 6108
                }
            }
        },
        Users: {
            IsirConfirmed: {
                View: 2511,
                Add: 2512,
                Edit: 2513,
                Delete: 2514
            },
            Students: {
                Personal: {
                    Dob: {
                        View: 2521,
                        Add: 2522,
                        Edit: 2523,
                        Delete: 2524
                    },
                    Ssn: {
                        View: 2531,
                        Add: 2532,
                        Edit: 2533,
                        Delete: 2534
                    },
                    SignatureAndInitials: {
                        View: 2541,
                        Add: 2542,
                        Edit: 2543,
                        Delete: 2544
                    },
                    PersonalInfo: {
                        View: 5711,
                        Add: 5712,
                        Edit: 5713,
                        Delete: 5714
                    },
                    Photo: {
                        Edit: 6162
                    }
                },
                Profile: {
                    View: 2551,
                    Add: 2552,
                    Edit: 2553,
                    Delete: 2554
                },
                Contacts: {
                    View: 2561,
                    Add: 2562,
                    Edit: 2563,
                    Delete: 2564
                },
                Activities: {
                    View: 2571,
                    Add: 2572,
                    Edit: 2573,
                    Delete: 2574
                },
                Ferpa: {
                    Add: 6101,
                    Delete: 6102,
                    Edit: 6103,
                    View: 6104
                },
                AcademicProgress: {
                    View: 6109
                },
                StatusesOf: {
                    Prospect: {
                        Edit: 6126
                    },
                    Applicant: {
                        Edit: 6127
                    },
                    Student: {
                        Edit: 6128
                    },
                    Alumni: {
                        Edit: 6129
                    },
                    Enrollment: {
                        Edit: 6148
                    },
                    TemporaryOut: {
                        Edit: 6149
                    },
                    PermanentOut: {
                        Edit: 6150
                    },
                    NeverAttended: {
                        Edit: 6151
                    }
                },
                ActivityLog: {
                    General: {
                        View: 6135
                    },
                    StatusHistory: {
                        View: 6136
                    },
                    Communication: {
                        View: 6137
                    }
                },
                CancelAndDrop: {
                    Edit: 6143
                },
                ActivitiesDeleteOthers: {
                    Delete: 6186
                },
                Profiles: {
                    Prospect: {
                        Add: 6191
                    },
                    Applicant: {
                        Add: 6192
                    },
                    Enrollment: {
                        Add: 6193
                    },
                    Student: {
                        Add: 6194
                    },
                    TemporaryOut: {
                        Add: 6195
                    },
                    PermanentOut: {
                        Add: 6196
                    },
                    Alumni: {
                        Add: 6197
                    },
                    NeverAttended: {
                        Add: 6198
                    }
                }
            },
            Staff: {
                Personal: {
                    Dob: {
                        View: 2611,
                        Add: 2612,
                        Edit: 2613,
                        Delete: 2614
                    },
                    Ssn: {
                        View: 2621,
                        Add: 2622,
                        Edit: 2623,
                        Delete: 2624
                    },
                    SignatureAndInitials: {
                        View: 2631,
                        Add: 2632,
                        Edit: 2633,
                        Delete: 2634
                    },
                    PersonalInfo: {
                        View: 5721,
                        Add: 5722,
                        Edit: 5723,
                        Delete: 5724
                    }
                },
                Profile: {
                    View: 2641,
                    Add: 2642,
                    Edit: 2643,
                    Delete: 2644
                },
                Contacts: {
                    View: 2651,
                    Add: 2652,
                    Edit: 2653,
                    Delete: 2654
                },
                HourlyRate: {
                    View: 6171,
                    Edit: 6172
                }
            },
            Others: {
                Personal: {
                    Dob: {
                        View: 2711,
                        Add: 2712,
                        Edit: 2713,
                        Delete: 2714
                    },
                    Ssn: {
                        View: 2721,
                        Add: 2722,
                        Edit: 2723,
                        Delete: 2724
                    },
                    SignatureAndInitials: {
                        View: 2731,
                        Add: 2732,
                        Edit: 2733,
                        Delete: 2734
                    },
                    PersonalInfo: {
                        View: 5731,
                        Add: 5732,
                        Edit: 5733,
                        Delete: 5734
                    }
                },
                Profile: {
                    View: 2741,
                    Add: 2742,
                    Edit: 2743,
                    Delete: 2744
                },
                Contacts: {
                    View: 2751,
                    Add: 2752,
                    Edit: 2753,
                    Delete: 2754
                }
            },
            Directory: {
                View: 2781,
                Add: 2782,
                Edit: 2783,
                Delete: 2784
            },
            Access: {
                Edit: 5913
            },
            DeleteAccount: {
                Delete: 6041
            },
            Self: {
                Personal: {
                    Dob: {
                        View: 6042,
                        Add: 6043,
                        Edit: 6044,
                        Delete: 6045
                    },
                    PersonalInfo: {
                        View: 6046,
                        Add: 6047,
                        Edit: 6048,
                        Delete: 6049
                    },
                    SignatureAndInitials: {
                        View: 6050,
                        Add: 6051,
                        Edit: 6052,
                        Delete: 6053
                    },
                    Ssn: {
                        View: 6054,
                        Add: 6055,
                        Edit: 6056,
                        Delete: 6057
                    }
                },
                Profile: {
                    View: 6058,
                    Add: 6059,
                    Edit: 6060,
                    Delete: 6061
                },
                Contacts: {
                    View: 6062,
                    Add: 6063,
                    Edit: 6064,
                    Delete: 6065
                }
            },
            UsersMerge: {
                Edit: 6111
            }
        },
        Resources: {
            MediaLibrary: {
                General: {
                    View: 2821,
                    Add: 2822,
                    Edit: 2823,
                    Delete: 2824
                },
                PinnedItems: {
                    Edit: 6142
                },
                SequenceOfItems: {
                    Edit: 6185
                }
            },
            Resources: {
                View: 2851,
                Add: 2852,
                Edit: 2853,
                Delete: 2854
            },
            Concerns: {
                View: 6081,
                Add: 6082,
                Edit: 6083,
                Delete: 6084
            }
        },
        Tasks: {
            Library: {
                View: 2831,
                Add: 2832,
                Edit: 2833,
                Delete: 2834
            },
            Director: {
                View: 6080
            }
        },
        Reports: {
            Academics: {
                ClassAttendance: {
                    View: 6039,
                    PermissionsToAccessOthers: {
                        View: 6040
                    }
                },
                General: {
                    View: 6096
                }
            },
            AdminReports: {
                GeneralReports: {
                    View: 6093
                },
                ComplianceReports: {
                    View: 6094
                },
                IpedsReports: {
                    View: 6095
                }
            },
            Admissions: {
                General: {
                    View: 6097
                }
            },
            FinancialAid: {
                General: {
                    View: 6098
                }
            },
            StudentAccounts: {
                General: {
                    View: 6099
                }
            },
            StudentServices: {
                General: {
                    View: 6100
                }
            }
        },
        Chat: {
            SmsChats: {
                View: 6169
            },
            GroupChats: {
                Add: 6170
            }
        }
    },
    Student: {
        Academics: {
            Externship: {
                View: 5011,
                Add: 5012,
                Edit: 5013,
                Delete: 5014
            },
            Practical: {
                General: {
                    View: 5021,
                    Add: 5022,
                    Edit: 5023,
                    Delete: 5024
                },
                TakingMediaWithApp: {
                    Add: 6201
                },
                UploadingMediaFromDevice: {
                    Add: 6202
                }
            },
            Workspace: {
                View: 5031,
                Add: 5032,
                Edit: 5033,
                Delete: 5034
            },
            DegreeAudit: {
                View: 6199
            }
        },
        Admissions: {
            View: 5041,
            Add: 5042,
            Edit: 5043,
            Delete: 5044
        },
        FinancialAid: {
            View: 5051,
            Add: 5052,
            Edit: 5053,
            Delete: 5054
        },
        CareerServices: {
            View: 5061,
            Add: 5062,
            Edit: 5063,
            Delete: 5064
        },
        StudentAccount: {
            StudentAccount: {
                View: 5111,
                Add: 5112,
                Edit: 5113,
                Delete: 5114
            },
            Workspace: {
                View: 5121,
                Add: 5122,
                Edit: 5123,
                Delete: 5124
            },
            Students: {
                FinAid: {
                    View: 6173,
                    Add: 6174,
                    Edit: 6175,
                    Delete: 6176
                },
                PaymentPlan: {
                    View: 6177,
                    Add: 6178,
                    Edit: 6179,
                    Delete: 6180
                },
                StudentLedger: {
                    View: 6181,
                    Add: 6182,
                    Edit: 6183,
                    Delete: 6184
                }
            }
        },
        StudentServicesAndAffairs: {
            StudentServices: {
                View: 5151,
                Add: 5152,
                Edit: 5153,
                Delete: 5154
            },
            AcademicAdvising: {
                View: 5161,
                Add: 5162,
                Edit: 5163,
                Delete: 5164
            }
        },
        Tasks: {
            View: 5211,
            Add: 5212,
            Edit: 5213,
            Delete: 5214
        },
        Users: {
            Personal: {
                Dob: {
                    View: 5251,
                    Add: 5252,
                    Edit: 5253,
                    Delete: 5254
                },
                Ssn: {
                    View: 5261,
                    Add: 5262,
                    Edit: 5263,
                    Delete: 5264
                },
                SignatureAndInitials: {
                    View: 5271,
                    Add: 5272,
                    Edit: 5273,
                    Delete: 5274
                },
                ProfilePhoto: {
                    View: 6187,
                    Edit: 6188
                }
            },
            Profile: {
                View: 5281,
                Add: 5282,
                Edit: 5283,
                Delete: 5284
            },
            Contacts: {
                View: 5291,
                Add: 5292,
                Edit: 5293,
                Delete: 5294
            },
            AcademicProgress: {
                OverallProgress: {
                    View: 6152
                },
                DailyProgress: {
                    View: 6153
                },
                Graduation: {
                    View: 6154
                },
                WeeklyPerformance: {
                    View: 6155
                },
                ProjectedGradDate: {
                    View: 6156
                },
                RankingAttendance: {
                    View: 6157
                },
                RankingAttendanceStreak: {
                    View: 6158
                },
                RankingDaysOff: {
                    View: 6159
                },
                RankingGpa: {
                    View: 6160
                },
                RankingCgpa: {
                    View: 6161
                }
            },
            Ferpa: {
                View: 6168
            }
        },
        Resources: {
            MediaLibrary: {
                View: 5611,
                Add: 5612,
                Edit: 5613,
                Delete: 5614
            },
            Concerns: {
                View: 6085,
                Add: 6086,
                Edit: 6087,
                Delete: 6088
            }
        },
        Documents: {
            View: 6114,
            Add: 6115,
            Edit: 6116,
            Delete: 6117
        }
    },
    Others: {
        Academics: {
            Externship: {
                View: 5311,
                Add: 5312,
                Edit: 5313,
                Delete: 5314
            },
            Practical: {
                View: 5321,
                Add: 5322,
                Edit: 5323,
                Delete: 5324
            },
            Workspace: {
                View: 5331,
                Add: 5332,
                Edit: 5333,
                Delete: 5334
            }
        },
        Admissions: {
            View: 5351,
            Add: 5352,
            Edit: 5353,
            Delete: 5354
        },
        FinancialAid: {
            View: 5381,
            Add: 5382,
            Edit: 5383,
            Delete: 5384
        },
        CareerServices: {
            View: 5391,
            Add: 5392,
            Edit: 5393,
            Delete: 5394
        },
        StudentAccount: {
            StudentAccount: {
                View: 5411,
                Add: 5412,
                Edit: 5413,
                Delete: 5414
            },
            Workspace: {
                View: 5421,
                Add: 5422,
                Edit: 5423,
                Delete: 5424
            }
        },
        StudentServicesAndAffairs: {
            StudentServices: {
                View: 5431,
                Add: 5432,
                Edit: 5433,
                Delete: 5434
            },
            AcademicAdvising: {
                View: 5441,
                Add: 5442,
                Edit: 5443,
                Delete: 5444
            }
        },
        Tasks: {
            View: 5511,
            Add: 5512,
            Edit: 5513,
            Delete: 5514
        },
        Users: {
            Personal: {
                Dob: {
                    View: 5551,
                    Add: 5552,
                    Edit: 5553,
                    Delete: 5554
                },
                Ssn: {
                    View: 5561,
                    Add: 5562,
                    Edit: 5563,
                    Delete: 5564
                },
                SignatureAndInitials: {
                    View: 5571,
                    Add: 5572,
                    Edit: 5573,
                    Delete: 5574
                },
                ProfilePhoto: {
                    View: 6189,
                    Edit: 6190
                }
            },
            Profile: {
                View: 5581,
                Add: 5582,
                Edit: 5583,
                Delete: 5584
            },
            Contacts: {
                View: 5591,
                Add: 5592,
                Edit: 5593,
                Delete: 5594
            }
        },
        Resources: {
            MediaLibrary: {
                View: 5621,
                Add: 5622,
                Edit: 5623,
                Delete: 5624
            },
            Concerns: {
                View: 6089,
                Add: 6090,
                Edit: 6091,
                Delete: 6092
            }
        },
        Documents: {
            View: 6118,
            Add: 6119,
            Edit: 6120,
            Delete: 6121
        }
    }
};
